import styled from 'styled-components';

const Container = styled.div`
  width: 100%;
  padding: 180px 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 300px;

  @media screen and (min-width: 768px) {
    padding: 0;
    min-height: 700px;
  }
`;

const Code = styled.p`
  font-weight: 700;
  font-size: 48px;
  line-height: 1.3em;
  color: #05D6E1;
  -webkit-font-smoothing: antialiased;
  margin-right: 20px;

  @media screen and (max-width: 767px) {
    font-size: 36px;
  }
`;

const Text = styled.p`
  font-weight: 700;
  font-size: 48px;
  line-height: 1.3em;
  color: #4d5256;
  -webkit-font-smoothing: antialiased;
  white-space: normal;
  word-break: break-all;
  word-wrap: break-word;

  @media screen and (max-width: 767px) {
    font-size: 36px;
  }
`;

const Button = styled.button`
  display: block;
  margin: 0 auto;
  margin-top: 50px;
  width: 250px;
  height: 56px;
  line-height: 56px;
  text-align: center;
  font-size: 16px;
  border-radius: 4px;
  color: #4d5256;
  background-color: #f1f5f5;
  cursor: pointer;
  border-radius: 5px;
  border: 0;

  &:hover {
    background-color: #eaeeef;
  }

  @media screen and (max-width: 767px) {
    font-size: 14px;
  }
`;

export { Container, Code, Text, Button };
